const VIEWABLE_EXTENSIONS = new Set([
	'pdf',
	'png',
	'jpg',
	'jpeg',
	'gif',
	'webp'
]);

const EXTENSION_TO_MIME: Record<string, string> = {
	pdf: 'application/pdf',
	png: 'image/png',
	jpg: 'image/jpeg',
	jpeg: 'image/jpeg',
	gif: 'image/gif',
	webp: 'image/webp',
};

function getExtension(filename: string): string | undefined {
	const lastDot = filename.lastIndexOf('.');
	if (lastDot === -1) return undefined;
	return filename.slice(lastDot + 1).toLowerCase();
}

export function getMimeTypeFromFilename(filename: string): string {
	const ext = getExtension(filename);
	return (ext && EXTENSION_TO_MIME[ext]) || 'application/octet-stream';
}

export function isViewableFile(filename: string): boolean {
	const ext = getExtension(filename);
	return Boolean(ext && VIEWABLE_EXTENSIONS.has(ext));
}
